<!-- ======= Footer Starts ======= -->
<footer id='mainFooter' class="mainFooter_Container">
        <div class="container-fluid" style="padding: 0;">
          <div class="container">
            <div class="footerContentSection">
              <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                <div class="col-md-3 col-sm-6 col-xs-12 floatLeft">
                  <h2 style="margin-left: 6%;">Useful Links</h2>
                  <div class="col-md-5 col-sm-6 col-xs-12 floatLeft">
                  <ul>
                    <li><a routerLink='/' (click)="gotoTop()">Home</a></li>
                    <li><a routerLink='/aboutus' (click)="gotoTop()">About us</a></li>
                    <!-- <li><a routerLink='/specialization' (click)="gotoTop()">Course</a></li> -->
                    <!-- <li><a routerLink='/guidelines' (click)="gotoTop()">Guidelines</a></li> -->
                    <!-- <li><a routerLink='/directory' (click)="gotoTop()">Directory</a></li> -->
                    <!-- <li><a routerLink='/downloads' (click)="gotoTop()">Download</a></li> -->
                    <li><a routerLink='/leadership-team' (click)="gotoTop()">Team</a></li>
                    <li><a routerLink='/faq' (click)="gotoTop()">FAQ</a></li>
                    <li><a routerLink='/bulletin' (click)="gotoTop()">Announcements</a></li>
                  </ul>
                </div>
                <div class="col-md-7 col-sm-6 col-xs-12 floatLeft">
                  <ul style="float: left;">
                    <li><a routerLink='/guidelines' (click)="gotoTop()">Guidelines</a></li>
                    <li><a routerLink='/directory' (click)="gotoTop()">Directory</a></li>
                    <li><a routerLink='/downloads' (click)="gotoTop()">Download</a></li>
                  </ul>
                </div>
                </div>
                <!-- <div class="col-md-7 col-sm-12 col-xs-12 nopad floatLeft"> -->
                  <div class="col-md-3 col-sm-6 col-xs-12 floatLeft">
                    <div>
                    <h2>Related Links</h2>
                    <ul>
                      <li><a href="https://aicte-india.org/">All India Council of Technical Education</a></li>
                      <li><a href="https://www.education.gov.in/en">Ministry of Education</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6 col-xs-12 floatLeft">
                  <h2>Student Learning Assessment</h2>
                  <p>
                    Nelson Mandela Marg, Vasant Kunj,<br>
                    New Delhi - 110070<br>
                    Phone: 011-29581527<br>
                    Email: parakh@aicte-india.org<br>
                    <!-- Email: parakh@aicte-india.org<br> -->
                  </p>
                </div>
                <div class="col-md-2 col-sm-12 col-xs-12 floatLeft socialIcon_Container">
                  <h2>Social</h2>
                  <ul class="socialIcon_List">
                    <li class="socialIcon_ListItem"><a href="https://www.facebook.com/officialaicte"><i class="fa fa-facebook"></i>Facebook</a></li>
                    <li class="socialIcon_ListItem"><a href="https://twitter.com/AICTE_INDIA"><i class="fa fa-twitter"></i>Twitter</a></li>
                    <li class="socialIcon_ListItem"><a href="https://www.youtube.com/MediaAICTE"><i class="fa fa-youtube"></i>Youtube</a></li>

                    <!-- <li class="socialIcon_ListItem"><a href="#"><i class="fa fa-pinterest"></i>Pinterest</a></li>
                    <li class="socialIcon_ListItem"><a href="#"><i class="fa fa-linkedin"></i>Linkedin</a></li>
                    <li class="socialIcon_ListItem"><a href="#"><i class="fa fa-instagram"></i>Instagram</a></li> -->
                    
                  </ul>
                </div>

              <!-- </div> -->
              <!-- <div class="col-md-3 col-sm-6 col-xs-12 floatLeft">
                  <h2>Write Us</h2>
                  <div>
                    <form id="formContact" class="form-horizontal" action="/action_page.php">
                      <div class="form-group">
                          <input type="email" class="form-control" id="Footermail" placeholder="Enter Email" name="email">
                      </div>
                      <div class="form-group">
                          <textarea class="form-control" id="Footermessage" name="message" rows="2" cols="50" placeholder="Enter Messages.."></textarea>
                        </div>
                      <div class="form-group text-center">
                          <button type="submit" class="btn SLA_button">Submit</button>
                      </div>
                    </form>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
      
          <div class="footerCopyright">
            <div class="container">
              <div class="copyright">
                &copy; Copyright 2021 AICTE STUDENT LEARNING ASSESSMENT PROJECT
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      <div class="clearfix"></div>
      
      <!-- ======= Footer Ends ======= -->
      